import { render, staticRenderFns } from "./ReviewStatusChip.vue?vue&type=template&id=2ac567da&"
import script from "./ReviewStatusChip.vue?vue&type=script&lang=js&"
export * from "./ReviewStatusChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports